import { tenantRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { TenantsKeys } from './types';

export const useGetTenantProfilePicture = (
  tenantId: number,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: [TenantsKeys.TENANT, tenantId, 'profile-picture'],
    queryFn: () => tenantRepo.getProfilePictureById(tenantId),
    enabled,
  });
};
